import axios from 'axios';
import dayjs from 'dayjs';
import qs from 'qs';

import { configs, ENV } from '@hero/configs';
import { QUERY_KEYS } from '@hero/constants';

import { queryClient } from '../clients';

import { createQueryKey } from './createQueryKey';
import { logoutAndRedirect } from './redirect';
import { storage } from './storage';

export function createAxios(baseURL) {
  let deviceId = localStorage.getItem('deviceId');
  if (!deviceId) {
    deviceId = crypto?.randomUUID() || Date.now() + Math.random();
    localStorage.setItem('deviceId', deviceId);
  }

  const headers = {
    'Content-Type': 'application/json',
    'x-merchant-code': configs.merchantName,
    'x-device-id': deviceId
  };

  const buildVersionMeta = document.querySelector('meta[name="build-version"]');
  if (buildVersionMeta) {
    const buildVersion = buildVersionMeta.getAttribute('content');
    const isValidDate = dayjs(buildVersion).isValid();

    if (isValidDate) {
      headers['x-build-version'] = buildVersion;
    }
  }

  const newInstance = axios.create({
    baseURL,
    headers,
    paramsSerializer: {
      serialize(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' });
      }
    }
  });

  newInstance.interceptors.request.use(config => {
    const userToken = storage.getUserToken();
    config.headers['X-Access-Token'] = userToken;

    let userData = {};
    try {
      userData = queryClient.getQueryData(createQueryKey(QUERY_KEYS.useGetUserKey));
      if (userData?.code) {
        config.headers['x-user-code'] = userData?.code;
      }
    } catch (error) {
      userData = {};
    }

    return config;
  });

  newInstance.interceptors.response.use(
    response => response,
    error => {
      if (error?.response) {
        if (
          error.response?.data?.error?.type === 'NotAuthenticated' ||
          error.response?.status === 401
        ) {
          logoutAndRedirect();
        }
      }
      return Promise.reject(error || 'Something went wrong!');
    }
  );

  return newInstance;
}

export function createContentStackAxios({ type = 'content_types' } = { type: 'content_types' }) {
  const headers = {
    'Content-Type': 'application/json',
    api_key: ENV.CONTENTSTACK_API_KEY,
    access_token: ENV.CONTENTSTACK_DELIVERY_TOKEN
  };

  const newInstance = axios.create({
    baseURL: `https://cdn.contentstack.io/v3/${type}`,
    headers,
    params: {
      environment: ENV.CONTENTSTACK_ENVIRONMENT
    }
  });

  return newInstance;
}
